import { ListResponse } from "../../../model/common/ListResponse";
import { ListCategory } from "../../../model/ListCategory";
import { axiosUtils } from "../../../network/axiosUtils";
import httpRequest from "../../../network/httpRequest";
import { HttpResponse } from "../../../network/types";

import {
  GetInquiryCategoriesQueryParams,
  GetInquiryListRequest,
  GetInquiryListResponse,
  PostInquiryRequest,
} from "./types";

const url = "/inquiries";
export const getInquiryList = async (queryParams: GetInquiryListRequest) => {
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.GET,
    url,
    queryParams: { ...queryParams, service: "REPAIR_SHOP_WEB" },
  });
  const res: GetInquiryListResponse = {
    inquiryList: response?.data.rows,
    count: response?.data.count,
  };
  return res;
};
export const postInquiry = async (requestBody: PostInquiryRequest) => {
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.POST,
    url,
    requestBody,
  });
  return response?.data.row;
};
export const getInquiryCategories = async (
  queryParams: GetInquiryCategoriesQueryParams
): Promise<ListResponse<ListCategory>> => {
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.GET,
    url: "inquiry-categories",
    queryParams,
  });

  return {
    rows: response?.data.rows,
    count: response?.data.count,
  };
};
